import { Number } from "components/common"
import Flex from "components/common/flex"
import { useEffect, useState } from "react"
import { convertToHMSString, getOBJValueByKey } from "utils"
import UserReportHover from "../components/common/userReportHover/userReportHover"

export const useTableData = (dataRows = [], dataMapping, TableComponents, shouldTransformData) => {
  const [state, setState] = useState({ data: [], columns: [] })

  useEffect(() => {
    shouldTransformData && setTableData()
  }, [dataRows, dataRows?.length, dataMapping])

  const mapRowByColumns = (column, row, newRow) => {
    if (column.children) {
      column.children.forEach(childColumn => {
        newRow[childColumn.dataIndex] = mapRowByColumns(childColumn, row, newRow)
      })
    } else if (Array.isArray(column.component)) {
      return renderMultiType(column, row, newRow)
    } else if (column.component === "string") {
      return getOBJValueByKey(row, column.dataKey)
    } else if (column.component === "time") {
      return convertToHMSString(getOBJValueByKey(row, column.dataKey))
    } else if (column.component === "number") {
      return <Number value={getOBJValueByKey(row, column.dataKey)} />
    } else if (column.component === "hover") {
      let parentIndex = column?.parentIndex
      let data = row?.hoverInfo?.[parentIndex]
      return (
        <UserReportHover
          data={data?.[column?.dataIndex]}
          hoverKeys={column?.hoverKeys}
          message={<Number value={getOBJValueByKey(row, column.dataKey)} />}
        />
      )
    } else if (column.component === "currency") {
      return <Number isCurrency={false} value={getOBJValueByKey(row, column.dataKey)} />
    } else if (!!TableComponents?.[column?.component]) {
      const Component = TableComponents[column.component]
      return <Component {...getOBJValueByKey(row, column.dataKey, row)} subKey={column.dataIndex} />
    } else {
      return row[column.dataIndex]
    }
  }
  const renderMultiType = (column, row, newRow) => {
    return (
      <Flex gap="6px" align="center" justify="center" wrap={false}>
        {column.component.map(type => {
          return mapRowByColumns({ ...column, component: type }, row, newRow)
        })}
      </Flex>
    )
  }
  const getRowData = item => {
    const obj = { ...item, key: item.key || item.id }
    dataMapping.forEach(column => {
      !column.children
        ? (obj[column.dataIndex] = mapRowByColumns(column, item, obj))
        : mapRowByColumns(column, item, obj)
    })
    if (!!item?.children) {
      obj.children = item.children.map(e => getRowData(e))
    }
    return obj
  }

  const setTableData = () => {
    if (dataRows && dataRows.length) {
      const tableData = []
      dataRows.forEach(item => {
        tableData.push(getRowData(item))
      })
      setState({
        columns: dataMapping.map(e => ({ ...e, dataKey: e.key })),
        data: tableData,
      })
    } else {
      setState(prevState => ({ data: [], columns: [] }))
    }
  }
  return shouldTransformData ? [state.data, state.columns] : [dataRows, dataMapping]
}
